module.exports = __webpack_public_path__ + "media/images/group-5fda46686570bc1287c21495ead69f1c.jpg";